(() => {
  const initialized = new WeakSet();
  const initialize = scope => {
    scope.querySelectorAll('[data-louford-boots]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const filters = root.querySelector('.LoufordBootsFilters');
      const cards = [...root.querySelectorAll('[data-boots-material]')];
      const count = root.querySelector('[data-boots-count]');
      if (!filters || !cards.length) return;
      filters.hidden = false;
      const applyFilter = value => {
        const update = () => {
          let visible = 0;
          cards.forEach(card => {
            card.hidden = value !== 'all' && card.dataset.bootsMaterial !== value;
            if (!card.hidden) visible++;
          });
          filters.querySelectorAll('[data-boots-filter]').forEach(button => {
            const active = button.dataset.bootsFilter === value;
            button.setAttribute('aria-pressed', String(active));
            button.classList.toggle('is-active', active);
          });
          if (count) count.textContent = (visible === 1 ? count.dataset.countOne : count.dataset.countTemplate).replace('[count]', String(visible));
        };
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
        else update();
      };
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-boots-filter]');
        if (button) applyFilter(button.dataset.bootsFilter);
      });
      root.querySelectorAll('[data-boots-filter-link]').forEach(link => {
        link.addEventListener('click', event => {
          if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) applyFilter(link.dataset.bootsFilterLink);
        });
      });
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#LoufordBoots"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const header = document.querySelector('.shopify-section--header');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 20;
        window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
